import FilterChip from 'LuxKit/Chips/FilterChip'
import SolidCheckCircleIcon from 'LuxKit/Icons/solid/SolidCheckCircleIcon'
import Group from 'components/utils/Group'
import { useIntl } from 'react-intl'

const DIETARY_REQUIREMENTS = [
  {
    dietaryRequirement: 'Vegan',
  },
  {
    dietaryRequirement: 'Vegetarian',
  },
  {
    dietaryRequirement: 'Gluten-free',
  },
  {
    dietaryRequirement: 'Halal',
  },
]

interface Props {
  dietaryRequirements: Array<{
    dietaryRequirement: string
    selected: boolean
  }>
  onDietaryRequirementSelect: (dietaryRequirement: string) => void
}

function DietaryRequirements({ dietaryRequirements, onDietaryRequirementSelect }: Props) {
  const intl = useIntl()

  const dietaryLabels: Record<string, string> = {
    'Vegan': intl.formatMessage({
      id: 'h2GzaINCHKRBMF9XHi5y',
      defaultMessage: 'Vegan',
      description: 'Selectable dietary requirement chip for vegan food preferences in the trip planner preferences',
    }),
    'Vegetarian': intl.formatMessage({
      id: 'bRT7y5PMpqqdBz6wyWut',
      defaultMessage: 'Vegetarian',
      description: 'Dietary requirement option for vegetarian food preferences',
    }),
    'Gluten-free': intl.formatMessage({
      id: 'KxbAyR-qyJeS8CR41vUg',
      defaultMessage: 'Gluten-free',
      description: 'Dietary requirement option for gluten-free food preferences',
    }),
    'Halal': intl.formatMessage({
      id: 'b0Zq417whLUff6hR962N',
      defaultMessage: 'Halal',
      description: 'Selectable dietary requirement chip for halal food preferences in the trip planner preferences',
    }),
  }

  return (
    <Group direction="horizontal" gap={12} wrap="wrap">
      {DIETARY_REQUIREMENTS.map((requirement) => {
        const isSelected = dietaryRequirements.find(
          d => d.dietaryRequirement === requirement.dietaryRequirement,
        )?.selected || false

        return (
          <FilterChip
            key={requirement.dietaryRequirement}
            selected={isSelected}
            size="large"
            onClick={() => onDietaryRequirementSelect(requirement.dietaryRequirement)}
            endIcon={isSelected ? <SolidCheckCircleIcon /> : undefined}
          >
            {dietaryLabels[requirement.dietaryRequirement] ?? requirement.dietaryRequirement}
          </FilterChip>
        )
      })}
    </Group>
  )
}

export default DietaryRequirements
